export default __webpack_public_path__ + "static/media/workout-3.56f9b032.png";